import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Card } from '../../shared/components';

/** A single figure with its label — the dashboards' building block. */
export default function KpiTile({
  label,
  value,
  icon,
  loading,
  alert,
  onClick,
}: {
  label: string;
  value: string | number;
  icon: string;
  loading?: boolean;
  /** Highlights the tile when there is something to act on. */
  alert?: boolean;
  onClick?: () => void;
}) {
  return (
    <Card sx={{ flex: '1 1 170px', minWidth: 170, py: 2 }}>
      <Stack direction='row' alignItems='center' gap={2} onClick={onClick} sx={{ cursor: onClick ? 'pointer' : 'default' }}>
        <Box
          sx={{
            display: 'grid',
            placeItems: 'center',
            width: 40,
            height: 40,
            borderRadius: 2,
            flexShrink: 0,
            color: 'primary.contrastText',
            bgcolor: alert ? 'warning.main' : 'primary.main',
          }}
        >
          <Icon icon={icon} width={22} />
        </Box>
        <Stack>
          {loading ? (
            <Skeleton variant='text' width={50} height={34} />
          ) : (
            <Typography sx={{ fontSize: '1.5rem', fontWeight: 600, lineHeight: 1.2 }}>{value}</Typography>
          )}
          <Typography variant='body2' color='text.secondary'>
            {label}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}
